var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    { attrs: { title: _vm.pageTitle, loading: _vm.loading } },
    [
      _c("sc-grid", {
        ref: "sc-grid",
        attrs: {
          data: _vm.refunds.items,
          "default-filters": _vm.defaultFilters,
          message: "Nenhum resultado encontrado",
          rules: _vm.rules,
          "has-backend-sorting": false,
          "has-backend-pagination": false,
          total: _vm.refunds.items.length,
          "default-sort-column": "status",
          "default-sort-direction": "asc"
        },
        on: {
          submit: function($event) {
            _vm.getDataTableReport($event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "filters-actions",
            fn: function(ref) {
              var isValid = ref.isValid
              var filters = ref.filters
              return [
                _c("sc-button", {
                  attrs: { text: "Exportar para o Excel" },
                  on: {
                    click: function($event) {
                      _vm.exportRefundToExcel(filters)
                    }
                  }
                }),
                _vm._v(" "),
                _c("sc-button", {
                  attrs: {
                    type: "button",
                    text: "Limpar filtros",
                    loading: _vm.loading
                  },
                  on: {
                    click: function($event) {
                      _vm.resetFilters()
                    }
                  }
                }),
                _vm._v(" "),
                _c("sc-button", {
                  attrs: {
                    type: "submit",
                    theme: "primary",
                    text: "Buscar",
                    loading: _vm.loading
                  }
                })
              ]
            }
          },
          {
            key: "filters",
            fn: function(ref) {
              var filters = ref.filters
              return [
                _c("div", { staticClass: "columns" }, [
                  _c(
                    "div",
                    { staticClass: "column is-2" },
                    [
                      _c(
                        "sc-field",
                        { attrs: { label: "Buscar por", prop: "type_filter" } },
                        [
                          _c(
                            "sc-select",
                            {
                              on: {
                                input: function($event) {
                                  _vm.changeComponent(_vm.componentRender)
                                }
                              },
                              model: {
                                value: _vm.componentRender,
                                callback: function($$v) {
                                  _vm.componentRender = $$v
                                },
                                expression: "componentRender"
                              }
                            },
                            _vm._l(_vm.componentDataObject, function(
                              component,
                              index
                            ) {
                              return _c(
                                "option",
                                {
                                  key: index,
                                  domProps: { value: component.value }
                                },
                                [_vm._v(_vm._s(component.name))]
                              )
                            })
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(_vm.componentRender, {
                        tag: "component",
                        attrs: {
                          rules: _vm.rules,
                          filters: filters,
                          "component-render": _vm.componentRender.component
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "table-columns",
            fn: function(ref) {
              var props = ref.props
              return [
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      field: "status",
                      label: "Status da PI",
                      sortable: ""
                    }
                  },
                  [_vm._v("\n        " + _vm._s(props.row.status) + "\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      field: "substatus",
                      label: "Substatus do PI",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(props.row.substatus) + "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      field: "number",
                      label: "Número do PI",
                      sortable: ""
                    }
                  },
                  [_vm._v("\n        " + _vm._s(props.row.number) + "\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      field: "reason_for_pidescription",
                      label: "Motivo de abertura",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(props.row.reason_for_pidescription) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      field: "tracking_code",
                      label: "Código de rastreamento",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(props.row.tracking_code) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      field: "order_number",
                      label: "Pedido",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(props.row.order_number) + "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      field: "end_customer_name",
                      label: "Destinatário",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(props.row.end_customer_name) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      field: "delivery_estimate_lp",
                      label: "Previsão da transportadora",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("date")(props.row.delivery_estimate_lp)) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      field: "answer_deadline",
                      label: "Prazo da resposta",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("date")(props.row.answer_deadline)) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-table-column",
                  {
                    attrs: {
                      field: "last_tracking_status",
                      label: "Último rastreamento",
                      sortable: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(props.row.last_tracking_status) +
                        "\n      "
                    )
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fe9231a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fe9231a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-refund/features/export-xls/PageRefund.vue
// module id = null
// module chunks = 